export default "__VITE_ASSET__DBpzGcne__"